import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';
import { UrlNames } from 'modules/app/constants';
import { configService } from 'modules/app/services';

import { mapFormDefinitionFromApi } from './mappers';

import type { FormDefinition, SubmitFormArgs } from 'modules/forms/types';

export const HOST_FEEDBACK_FORM_KEY = 'hosted-natter-host-feedback';

// Prefetched when a host enters the event room and read when it ends, which can be hours later.
// No cache tags: a definition only changes on a form-service deploy, and nothing this app does
// (submitting included) changes one, so there is nothing to invalidate. The cache expiry is the refresh.
const SIX_HOURS_S = 6 * 60 * 60;

export const formsApi = createApi({
  reducerPath: 'formsApi',
  baseQuery: axiosBaseQuery({ baseURL: () => configService.getUrl(UrlNames.FormServiceApi) }),
  endpoints: (builder) => ({
    getForm: builder.query<FormDefinition | null, string>({
      query: (formKey) => `/forms/${encodeURIComponent(formKey)}`,
      transformResponse: mapFormDefinitionFromApi,
      keepUnusedDataFor: SIX_HOURS_S,
    }),
    submitForm: builder.mutation<{ submissionId: string }, SubmitFormArgs>({
      query: ({ formKey, body }) => ({
        url: `/forms/${encodeURIComponent(formKey)}/submissions`,
        method: 'POST',
        data: body,
      }),
    }),
  }),
});

export const { useGetFormQuery, useSubmitFormMutation } = formsApi;
